module.exports = {"label":"Date of birth","placeholder":"Enter date of birth","dayFormat":"DD","monthFormat":"MM","yearFormat":"YY","age_requirement":"You must be at least {{age}} years old","accept_terms":"By clicking on the button I agree to the","accept_terms_link":"Terms of Service","check_format":"Please double-check the format","day":"Day","month":"Month","year":"Year"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/birthdate.json
// module id = 511
// module chunks = 245 988